import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class FullNamePipe implements PipeTransform {
  public static getFullName(firstName: string | undefined, lastName: string | undefined): string {
    return firstName && lastName ? `${firstName} ${lastName}` : firstName ? firstName : lastName ? lastName : '';
  }

  transform(firstName: string | undefined, lastName: string | undefined): string {
    return FullNamePipe.getFullName(firstName, lastName);
  }
}
